<template lang="pug">
  li.dropdown.user.notifications-menu
    a.dropdown-toggle(href='#', data-toggle='dropdown' title="お知らせ")
      span.glyphicon.glyphicon-bell
      span.label.label-danger(v-if="informationCount > 0") {{informationCount > 999 ? "999+" : informationCount}}
      span.hidden-sm.hidden-md.hidden-lg お知らせ
    ul.dropdown-menu
      li.header.bg-light-blue(@click.stop="")
        template(v-if="pagination.count === 0") 未読・作業依頼のお知らせはありません。
        template(v-else) {{pagination.count}} 件 の未読・作業依頼のお知らせがあります。
      li
        ul.menu
          li(v-for="item in list", :key="item.id")
            router-link(:to="{name: 'information-detail', params: getParams({id: '' + item.id})}")
              info-icon(:functionCode='item.function', :infoType="item.type", showMode="list")
              | {{item.message}}
      li.footer
        router-link(:to="{name: 'information', params: getParams()}") お知らせ一覧を表示

</template>

<script>
import InfoIcon from '@/components/molecules/InfoIcon'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const TopRepository = RepositoryFactory.get('top')

export default {
  name: 'InformationDigest',
  components: { InfoIcon },
  data: function () {
    return {
      list: [],
      pagination: { count: 0 },
      informationCount: 0
    }
  },
  watch: {
    // storeのwatchの仕方は他にもある
    // https://stackoverflow.com/questions/43270159/vuejs-2-how-to-watch-store-values-from-vuex
    '$store.state.base.headerInfoReloader': function (headerInfoReloader) {
      if (headerInfoReloader) {
        this.getList()
      }
    }
  },
  created: function () {
    // ログインしている場合のみ取得取得する
    if (this.$store.getState('token')) {
      this.getList()
      // this.$store.dispatch('reloadHeaderInfo')
    }
  },
  methods: {
    /**
     * リンクの引数を設定する
     */
    getParams: function (params) {
      params = params || {}
      params.init = true
      return params
    },
    getList: function () {
      const vm = this
      const sendParams = {'header': this.app_flag.ON}

      // お知らせ一覧を取得する
      TopRepository.getInfoMessages(sendParams)
        .then(function (response) {
          const data = vm.getApiData(response)
          vm.list = data.data
          vm.pagination = data.pagination
          vm.informationCount = vm.pagination.count
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
// ドロップダウンリスト
.dropdown-menu {
  width: 330px !important;
}

// 0049427
.navbar-nav > .notifications-menu > .dropdown-menu > li .menu {
  overflow-x: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/InfoDigest.vue